import { useCustomTranslation } from "../../hooks/useCustomTranslation";

export const GalleryLoader = (): JSX.Element => {
  const { t } = useCustomTranslation("Notifications");
  return (
    <div className="gallery-notice-container">
      <div className="gallery-notice-container__content">
        <p>
          {t("LoadingGallery")}
          <span className="ellipsis-anim">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </div>
  );
};
